(function() {
  'use strict';

  if (window.GibbonWinnerPages) return;

  function slideAmount(viewport, selector) {
    var slide = viewport.querySelector(selector);
    if (!slide) return viewport.clientWidth * 0.8;
    var track = slide.parentElement;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function initTicker(ticker) {
    if (ticker.dataset.gabTickerReady === 'true') return;
    ticker.dataset.gabTickerReady = 'true';

    var mobileQuery = window.matchMedia('(max-width: 599px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function canAnimate() {
      return mobileQuery.matches && !reducedMotionQuery.matches;
    }

    function updateControl() {
      if (!canAnimate()) {
        ticker.removeAttribute('role');
        ticker.removeAttribute('tabindex');
        ticker.removeAttribute('aria-pressed');
        ticker.setAttribute('aria-label', 'SlackBoard key features');
        return;
      }

      var paused = ticker.classList.contains('is-paused');
      ticker.setAttribute('role', 'button');
      ticker.setAttribute('tabindex', '0');
      ticker.setAttribute('aria-pressed', paused ? 'true' : 'false');
      ticker.setAttribute('aria-label', (paused ? 'Resume' : 'Pause') + ' SlackBoard key features ticker');
    }

    function toggle() {
      if (!canAnimate()) return;
      ticker.classList.toggle('is-paused');
      updateControl();
    }

    ticker.addEventListener('click', toggle);
    ticker.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateControl);
      reducedMotionQuery.addEventListener('change', updateControl);
    } else {
      mobileQuery.addListener(updateControl);
      reducedMotionQuery.addListener(updateControl);
    }
    updateControl();
  }

  function initCarousel(carousel) {
    if (carousel.dataset.gabCarouselReady === 'true') return;
    var viewport = carousel.querySelector('[data-gab-viewport]');
    var prev = carousel.querySelector('[data-gab-prev]');
    var next = carousel.querySelector('[data-gab-next]');
    if (!viewport || !prev || !next) return;
    carousel.dataset.gabCarouselReady = 'true';

    function maxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function update() {
      var max = maxScroll();
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function() {
      var selector = carousel.classList.contains('gab-why') ? '.gab-why-card' : '.gab-product';
      viewport.scrollTo({
        left: Math.max(0, viewport.scrollLeft - slideAmount(viewport, selector)),
        behavior: 'smooth'
      });
    });
    next.addEventListener('click', function() {
      var selector = carousel.classList.contains('gab-why') ? '.gab-why-card' : '.gab-product';
      viewport.scrollTo({
        left: Math.min(maxScroll(), viewport.scrollLeft + slideAmount(viewport, selector)),
        behavior: 'smooth'
      });
    });
    viewport.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initReviews(reviews) {
    if (reviews.dataset.gabReviewsReady === 'true') return;
    reviews.dataset.gabReviewsReady = 'true';

    function start() {
      if (!document.documentElement.contains(reviews)) return;
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
        window.setTimeout(start, 100);
        return;
      }

      var $reviews = window.jQuery(reviews);
      var $track = $reviews.find('[data-gab-reviews-track]');
      if (!$track.length || $track.hasClass('slick-initialized')) return;
      reviews.classList.add('gab-reviews--enhanced');

      function updateToggles() {
        $track.find('.gab-review').each(function() {
          var review = this;
          var reviewText = review.querySelector('.gab-review__text');
          var toggle = review.querySelector('[data-gab-review-toggle]');
          if (!reviewText || !toggle) return;
          if (review.classList.contains('gab-review--expanded')) {
            review.classList.add('gab-review--toggleable');
            toggle.hidden = false;
            return;
          }
          review.classList.remove('gab-review--toggleable');
          toggle.hidden = true;
          var truncated = reviewText.scrollHeight > reviewText.clientHeight + 1;
          review.classList.toggle('gab-review--toggleable', truncated);
          toggle.hidden = !truncated;
        });
      }

      function refresh() {
        window.requestAnimationFrame(function() {
          updateToggles();
          if ($track.hasClass('slick-initialized')) $track.slick('setPosition');
        });
      }

      $track.on('click.gabReviewToggle', '[data-gab-review-toggle]', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var review = this.closest('[data-gab-review-index]');
        if (!review) return;
        var index = review.getAttribute('data-gab-review-index');
        var expand = this.getAttribute('aria-expanded') !== 'true';

        $track.find('[data-gab-review-index]').each(function() {
          if (this.getAttribute('data-gab-review-index') !== index) return;
          var matchingToggle = this.querySelector('[data-gab-review-toggle]');
          var matchingLabel = this.querySelector('[data-gab-review-toggle-label]');
          this.classList.add('gab-review--toggleable');
          this.classList.toggle('gab-review--expanded', expand);
          if (matchingToggle) {
            matchingToggle.hidden = false;
            matchingToggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
          }
          if (matchingLabel) matchingLabel.textContent = expand ? 'Show less' : 'Read more';
        });
        refresh();
      });

      $track.on('init afterChange', refresh);
      $track.slick({
        centerMode: true,
        variableWidth: true,
        initialSlide: 1,
        infinite: true,
        focusOnSelect: true,
        dots: true,
        arrows: true,
        appendDots: $reviews.find('[data-gab-reviews-dots]'),
        prevArrow: $reviews.find('[data-gab-reviews-prev]'),
        nextArrow: $reviews.find('[data-gab-reviews-next]'),
        customPaging: function(_slider, index) {
          return '<button type="button" class="gab-dot" aria-label="Go to review ' + (index + 1) + '"></button>';
        }
      });

      var resizeTimer;
      window.addEventListener('resize', function() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(refresh, 100);
      }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    }
    start();
  }

  function initAppButton(button) {
    if (button.dataset.gabAppReady === 'true') return;
    button.dataset.gabAppReady = 'true';
    var userAgent = window.navigator.userAgent || '';
    var android = /Android/i.test(userAgent);
    var ios = /iPad|iPhone|iPod/i.test(userAgent)
      || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
    var url = android
      ? button.getAttribute('data-gab-app-android-url')
      : button.getAttribute('data-gab-app-ios-url');
    if (url && (android || ios)) button.setAttribute('href', url);
  }

  function initTrigger(trigger, kind) {
    var readyKey = kind === 'quiz' ? 'gabQuizReady' : 'gabCompareReady';
    if (trigger.dataset[readyKey] === 'true') return;
    trigger.dataset[readyKey] = 'true';
    trigger.addEventListener('click', function() {
      if (kind === 'quiz' && window.GibbonProductGuide && window.GibbonProductGuide.openQuiz) {
        window.GibbonProductGuide.openQuiz();
        return;
      }
      if (kind === 'compare' && window.GibbonProductGuide && window.GibbonProductGuide.openCompare) {
        window.GibbonProductGuide.openCompare();
        return;
      }
      var chart = document.querySelector('.comparisonChart');
      var overlay = document.querySelector('.comparison_overlay');
      var quiz = document.getElementById('quiz');
      if (kind === 'quiz') {
        if (chart) chart.classList.remove('active');
        if (overlay) {
          overlay.classList.remove('active');
          overlay.style.display = 'none';
        }
        if (quiz) quiz.classList.add('active');
      } else {
        if (chart) chart.classList.add('active');
        if (overlay) {
          overlay.classList.add('active');
          overlay.style.display = 'block';
        }
      }
    });
  }

  function init(root) {
    var scope = root || document;
    document.body.classList.add('gab-winner-page-visible');
    scope.querySelectorAll('.gab-key-features').forEach(initTicker);
    scope.querySelectorAll('[data-gab-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-gab-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-gab-c-app-button]').forEach(initAppButton);
    scope.querySelectorAll('[data-gab-quiz]').forEach(function(trigger) { initTrigger(trigger, 'quiz'); });
    scope.querySelectorAll('[data-gab-compare]').forEach(function(trigger) { initTrigger(trigger, 'compare'); });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('#closeQuiz')) {
      var quiz = document.getElementById('quiz');
      if (quiz) quiz.classList.remove('active');
    }
    if (event.target.closest('.comparisonChart .qeTrigger')) {
      var chart = document.querySelector('.comparisonChart');
      var overlay = document.querySelector('.comparison_overlay');
      var quizDialog = document.getElementById('quiz');
      if (chart) chart.classList.remove('active');
      if (overlay) {
        overlay.classList.remove('active');
        overlay.style.display = 'none';
      }
      if (quizDialog) quizDialog.classList.add('active');
    }
  });

  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  window.GibbonWinnerPages = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
